import styled from "styled-components";

export const Container = styled.div`
  min-height: calc(100vh - 120px);
  display: flex;
  background: transparent;
  justify-content: center;
  align-items: center;
  border-color: #103830;
  border: 4px solid;
  border-radius: 10px;
  width: 90%;
  max-width: 800px;
  min-height: 300px;
  margin: 40px auto;
  padding: 30px;
  background-color: #b8b8b81a;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
`;
export const Title = styled.span`
  font-size: 1.8rem;
  font-weight: bold;
  color: #203b34;
  text-transform: uppercase;
`;
